import classNames from 'classnames';
import React, { useCallback, useEffect, useState, useRef } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createSelector } from 'reselect';
import KeepAlive, { useActivate, useUnactivate, useAliveController } from 'react-activation';

import { logging, logPostInfo } from '../../actions/log';
import {
  cancelMineCollectOrSetup,
  getMineCollectList,
  getMineSetupList,
  setScroll,
} from '../../actions/wallpaper';
import Loading from '../../components/Loading/Loading';
import ScrollTop from '../../components/ScrollTop/ScrollTop';
import WallpaperCard from '../../components/WallpaperCard/WallpaperCard';
import Blank from './Blank';
import Nav from './Nav';
import styles from './WallpaperMine.module.less';

const labelList = [
  {
    name: 'setup',
    text: '曾用壁纸',
    tagId: 'setup',
  },
  {
    name: 'collect',
    text: '我收藏的',
    tagId: 'collect',
  },
];

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectMineInfo = createSelector(
  state => {
    return state.wallpaper;
  },
  info => {
    return info.mineInfo;
  },
);

function WallpaperMine({ match }) {
  // export default memo(() => {
  // export default function WallpaperMine({ match }) {
  const [load, setLoad] = useState(null);
  const [active, setActive] = useState('setup');
  const logInfoData = useSelector(selectLogInfo);

  const mineInfo = useSelector(selectMineInfo);

  const dispatch = useDispatch();
  const history = useHistory();
  const { action } = history;
  const pageContent = useRef();

  const [showNumber, setShowNumber] = useState(8);

  const [initTime, setInitTime] = useState(+new Date());

  // 浏览时长打桩
  const leaveTimeLog = useCallback(() => {
    const leaveTime = +new Date();
    dispatch(
      logging({
        category: 'I',
        action: 'View_Time',
        label: '',
        param2: {
          source: `Wallpaper_Mine`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          initTime,
          leaveTime,
          time: leaveTime - initTime,
        },
      }),
    );
  }, [initTime]);

  const pagePvLog = useCallback(() => {
    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'P_Wallpaper_Mine',
        label: '',
        param2: {
          source: 'Wallpaper_Mine',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source: 'Wallpaper_Mine',
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
  });

  useActivate(() => {
    setInitTime(+new Date());
  });
  useUnactivate(() => {
    leaveTimeLog();
  });

  useEffect(() => {
    pagePvLog();
  }, []);
  useActivate(() => {
    pagePvLog();
  });

  useEffect(() => {
    if (load === null) {
      setLoad(true);
    } else {
      setLoad(false);
    }
  }, [mineInfo]);

  const requestFunc = params => {
    switch (params.tagId) {
      case 'collect':
        dispatch(getMineCollectList(params));
        break;
      default:
        dispatch(getMineSetupList(params));
        break;
    }
  };

  useEffect(() => {
    let tagId = active;
    if (match.params && match.params.tagId) {
      tagId = match.params.tagId;
      setActive(tagId);
    }

    const {
      location: { search },
    } = history;

    if (action === 'POP' && mineInfo.list.length !== 0) {
      setActive(mineInfo.pagenation.tagId);
      return;
    }
    if (!search || mineInfo.list.length === 0) {
      requestFunc({
        ...mineInfo.pagenation,
        tagId,
        skip: 0,
        refresh: true,
      });
    }
  }, []);

  const handleTags = tagId => () => {
    if (tagId === active) {
      return;
    }
    setActive(tagId);
    requestFunc({
      ...mineInfo.pagenation,
      tagId,
      skip: 0,
      refresh: true,
    });
    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'C_Wallpaper_Mine_Tag',
        param2: {
          source: `Wallpaper_Mine||${active}`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          tagId,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source: `Wallpaper_Mine||${active}`,
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
  };

  const loadMore = () => {
    if (!mineInfo.load && mineInfo.pagenation.tagId === active) {
      const params = {
        ...mineInfo.pagenation,
      };
      delete params.count;
      delete params.tagId;
      requestFunc({
        ...mineInfo.pagenation,
        tagId: active,
        refresh: false,
      });
    }
  };
  const handleCancel = async params => {
    const typeActive = active === 'collect' ? 2 : 4;
    if (typeActive !== params.type) {
      return;
    }
    const index = mineInfo.list.findIndex(item => item.wallpaperId === params.wallpaperId);
    dispatch(
      cancelMineCollectOrSetup({
        wallpaperId: params.wallpaperId,
        type: active === 'collect' ? 2 : 4,
      }),
    );
    if (index > -1 && mineInfo.list.length < mineInfo.pagenation.count) {
      requestFunc({
        ...mineInfo.pagenation,
        skip: mineInfo.pagenation.skip - 1 > 0 ? mineInfo.pagenation.skip - 1 : 0,
        tagId: active,
        refresh: false,
      });
    }
  };

  // 监听浏览器大小变化自动适应
  useEffect(() => {
    window.addEventListener('resize', handleResize, false);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleResize = useCallback(e => {
    const clientWidth = (document.body && document.body.clientWidth) || 1060;
    if (clientWidth < 1330) {
      setShowNumber(6);
    } else if (clientWidth >= 1330 && clientWidth < 1465) {
      setShowNumber(6);
    } else if (clientWidth >= 1465 && clientWidth < 1600) {
      setShowNumber(9);
    } else if (clientWidth >= 1600 && clientWidth < 1870) {
      setShowNumber(9);
    } else if (clientWidth >= 1870) {
      setShowNumber(12);
    }
  }, []);

  const getClassType = useCallback((index = 0, number = 8) => {
    const series = {
      '6': {
        big: [1, 3, 5],
        big_space: [2, 4, 0],
      },
      '9': {
        big: [1, 4, 7],
        big_space: [2, 3, 5, 6, 8, 0],
      },
      '12': {
        big: [1, 5, 9],
        big_space: [2, 3, 4, 6, 7, 8, 10, 11, 0],
      },
    };
    const pos = (index + 1) % parseInt(number);
    let classType = 'big';
    // if (series[number].small.indexOf(pos) > -1) {
    //   classType = 'small';
    // }
    // if (series[number].small_space.indexOf(pos) > -1) {
    //   classType = 'small_space';
    // }
    if (series[number].big.indexOf(pos) > -1) {
      classType = 'big';
    }
    if (series[number].big_space.indexOf(pos) > -1) {
      classType = 'big_space';
    }
    return classType;
  }, []);

  if ((load || load === null) && action !== 'POP') {
    return (
      <div className={styles.loading}>
        <Loading />
      </div>
    );
  }

  return (
    <div className={styles.page} ref={pageContent}>
      <div className={styles.page_container}>
        <Nav active="wpmine" />
        <div className={styles.label_container}>
          {labelList.map(item => (
            <div
              key={item.tagId}
              className={classNames(styles.label_item, { [styles.active]: active === item.tagId })}
            >
              <span onClick={handleTags(item.tagId)}>{item.text}</span>
            </div>
          ))}
        </div>
        {mineInfo.pagenation.count > 0 && (
          <InfiniteScroll
            pageStart={1}
            loadMore={loadMore}
            hasMore={mineInfo.list.length < mineInfo.pagenation.count}
            loader={
              <div className="loader" key={0}>
                --加载中--
              </div>
            }
            initialLoad={!mineInfo.list.length}
            useWindow={false}
            getScrollParent={() => pageContent.current}
          >
            <div className={styles.mine}>
              {mineInfo.list.map((item, index) => {
                return (
                  <WallpaperCard
                    wallpaper={item}
                    key={item.wallpaperId}
                    cardInfo={{
                      pageSource: 'mine',
                      pageTage: active || 'collect',
                      classType: getClassType(index, showNumber),
                      isCollect: active === 'setup',
                      isWallpaper: true,
                      isPreview: true,
                      isDeleteColl: active === 'collect',
                      isDeleteUsed: active === 'setup',
                      deleteCallback: handleCancel,
                    }}
                    logInfo={{ source: `Wallpaper_Mine||${active}` }}
                  />
                );
              })}
            </div>
            {/* {mineInfo.list.length >= mineInfo.pagenation.count && (
              <div className="loader">--到底啦--</div>
            )} */}
          </InfiniteScroll>
        )}

        <ScrollTop node={pageContent.current} />
      </div>
      <div className={styles.blank}>
        {mineInfo.pagenation.count < 1 && <Blank load={mineInfo.load} />}
      </div>
    </div>
  );
}
// });

export default porps => {
  const history = useHistory();
  const { refresh } = useAliveController();

  useEffect(() => {
    if (history.action === 'PUSH') {
      refresh(`wpmine`);
    }
  }, []);
  return (
    <KeepAlive name="wpmine">
      <WallpaperMine {...porps} />
    </KeepAlive>
  );
};
